"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/*
 * 8x8 Confidential & Proprietary || Copyright 2025 8x8, Inc. or its affiliates. All Rights Reserved.
 *  _____      _____
 * |  _  |    |  _  |
 *  \ V /__  __\ V /   ___ ___  _ __ ___
 *  / _ \\ \/ // _ \  / __/ _ \| '_ ` _ \
 * | |_| |>  <| |_| || (_| (_) | | | | | |
 * \_____/_/\_\_____(_)___\___/|_| |_| |_|
 *
 * @License https://www.8x8.com/terms-and-conditions/software-development-kit-license-agreement
 * @Author Comanici Paul
 * @Date 2025/08/05
 */
const LOCALSTORAGE_KEY = "eght_pui-partner-comm-logging-enabled";
function activate() {
    try {
        localStorage.setItem(LOCALSTORAGE_KEY, "true");
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
    }
    catch (e) {
        /* noop */
    }
}
function deactivate() {
    try {
        localStorage.setItem(LOCALSTORAGE_KEY, "false");
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
    }
    catch (e) {
        /* noop */
    }
}
function getStatus() {
    try {
        return localStorage.getItem(LOCALSTORAGE_KEY) === "true";
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
    }
    catch (e) {
        return false;
    }
}
exports.default = { activate, deactivate, getStatus };
//# sourceMappingURL=logging.js.map